// ABOUTME: Topbar trigger showing the current language's flag, opening the language chooser popover.
// ABOUTME: Sits next to the settings button and lets the user pick any available UI language.

import { ButtonBase, useTheme } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { tokens } from "../../../../theme";
import { localeSettings } from "../../../../utils/locales";
import MPOChooseLanguage from "../../ModalsPopover/MPOChooseLanguage";

const LanguagePicker = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {t} = useTranslation();
    const language = useSelector((state) => state.settings.language);

    const [anchorEl, setAnchorEl] = useState(null);
    const popoverOpen = Boolean(anchorEl);
    const popoverId = popoverOpen ? 'language-popover' : undefined;

    return (
        <>
            <ButtonBase
                aria-label={t('language')}
                onClick={(event) => setAnchorEl(event.currentTarget)}
                TouchRippleProps={{
                    style: {
                        color: theme.palette.mode === "dark" ? "rgba(255,255,255,.5)" : 'rgba(49, 65, 95, 0.5)'
                    }
                }} // Directly styling the ripple here
                variant='contained'
                sx={{
                    background:theme.palette.mode === "dark" ? colors.nav["linkBg"]  : colors.grey[100],
                    width:32,
                    height:32,
                    borderRadius:20,
                    padding:0,
                    minWidth:0,
                    boxShadow:"none",
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"center",
                    transition:"250ms",
                    color: colors.txt["primary"],
                    opacity:1,
                    overflow:"hidden",
                    "& svg" : {
                        width:20,
                        height:15,
                    },
                    "&:hover" : {
                        transition:"250ms",
                        background:theme.palette.mode === "dark" ? colors.grey[300] : "white",
                        boxShadow:"0px 2px 8px rgba(49, 65, 95, 0.25)"
                    },
                    "@media screen and (max-width: 47.9375em)" : {
                        width:32,
                        height:32,
                        borderRadius:16
                    }
                }}
            >
                {localeSettings[language]?.flag}
            </ButtonBase>

            <MPOChooseLanguage
                id={popoverId}
                open={popoverOpen}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
            />
        </>
    );
}

export default LanguagePicker;
